import { GoogleGenAI } from "@google/genai";
import { QuizQuestion } from "../types";
import { Language, t } from "../../../../i18n";

const ai = new GoogleGenAI({ apiKey: import.meta.env.VITE_GOOGLE_API_KEY });

export async function generateQuizQuestions(category: string, count: number = 10): Promise<QuizQuestion[]> {
  try {
    const prompt = `You are a football trivia expert. 
    Create ${count} multiple-choice questions for the category: "${category}".
    (Ensure the category name is in English, e.g., 'World Cup', 'Tactics', 'Players').
    The questions should be challenging and interesting for football fans.
    Each question must have exactly 4 options.
    Format the output as a JSON array of objects with the following structure:
    {
      "id": "string (unique)",
      "category": "${category}",
      "question": "string (in Korean)",
      "options": ["string", "string", "string", "string"] (in Korean),
      "correctAnswer": number (0-3 index),
      "explanation": "string (brief explanation in Korean)"
    }
    Only return the JSON array, nothing else.`;

    const response = await ai.models.generateContent({
      model: import.meta.env.VITE_GEMINI_LITE_MODEL,
      contents: prompt,
      config: {
        responseMimeType: "application/json"
      }
    });

    const questions = JSON.parse(response.text || "[]");
    return questions;
  } catch (error) {
    console.error("Quiz Generation Error:", error);
    return [];
  }
}

export async function getQuizCommentary(score: number, correctCount: number, lang: Language = 'ko') {
  if (correctCount === 10) {
    return t(lang, 'footy_master_commentary_perfect');
  } else if (correctCount >= 8) {
    return t(lang, 'footy_master_commentary_great');
  } else if (correctCount >= 5) {
    return t(lang, 'footy_master_commentary_good');
  } else if (correctCount >= 3) {
    return t(lang, 'footy_master_commentary_average');
  } else {
    return t(lang, 'footy_master_commentary_poor');
  }
}
